import { cloneDeep, get, find } from "lodash-es";
import { arrayify } from "../../../../lib/utils/array";
import svg from "../../../../lib/assets/actionIcons/intoBox.svg";
/** 取一个尽量算是默认的slotId出来 */
function getSomeSlotIdFromCompMeta(compMeta) {
  // 把函数插槽和没插槽的都扔掉
  if (typeof compMeta.slots === 'function' || !compMeta.slots) return undefined;
  const defaultSlot = Array.isArray(compMeta.slots) ? compMeta.slots.find(slot => slot.id === 'default') : undefined;
  const slotId = (defaultSlot === null || defaultSlot === void 0 ? void 0 : defaultSlot.id) || get(compMeta, ['slots', 0, 'id']);
  if (!slotId) return undefined;
  const slotMeta = find(compMeta.slots, {
    id: slotId
  });
  // frozen的不考虑默认装入 在uicore中会筛掉分列和选项卡
  if (slotMeta && slotMeta.frozen) return undefined;
  return slotId;
}
/** 生成一个基础的PlaceCompInsideAdvancedRequest */
function wrapperAdvancedReq(ctx, item, slotId) {
  return {
    name: item.name || '',
    icon: item.icon || '',
    slotId
  };
}
/** compMeta经过这个处理之后得到Array<PlaceCompInsideAdvancedRes> */
function wrapperPlaceInsideRequest(ctx, item) {
  if (typeof item.placeCompInside !== 'function') {
    // 随便找个装入的slotid
    const slotId = getSomeSlotIdFromCompMeta(item);
    if (!slotId) return [];
    return [wrapperAdvancedReq(ctx, item, slotId)];
  }
  // item.placeCompInside is function
  try {
    const res = item.placeCompInside(ctx);
    if (typeof res === 'string') {
      // 这时res 就是插槽id了
      return [wrapperAdvancedReq(ctx, item, res)];
    }
    if (Array.isArray(res)) {
      return res;
    }
    if (typeof res === 'object') {
      return [res];
      // 这时候res是 PlaceCompInsideAdvancedRes
    }
  } catch (e) {
    console.log('组件', item.meta.name, 'placeCompInside出错', e);
  }
  return [];
}
/** 从compMeta生成一个默认的Layout */
function genCompLayout(ctx, item) {
  var _item$meta, _layoutAns$pop;
  const {
    designer
  } = ctx;
  if (!designer || !((_item$meta = item.meta) !== null && _item$meta !== void 0 && _item$meta.id)) return;
  // 从组件id生成要装入的容器的layout
  const layoutAns = designer.getMaterialBoxGroups({
    filter: component => component.id === item.meta.id
  });
  // layoutAns会是一个推荐列表的数组 由于是按已有id进行filter的 直接取唯一即可
  const originLayout = (_layoutAns$pop = layoutAns.pop()) === null || _layoutAns$pop === void 0 || (_layoutAns$pop = _layoutAns$pop.items) === null || _layoutAns$pop === void 0 || (_layoutAns$pop = _layoutAns$pop.pop()) === null || _layoutAns$pop === void 0 ? void 0 : _layoutAns$pop.layout;
  if (!originLayout) return;
  return originLayout;
}
// 对未提供默认的getLayout的Request进行处理
function checkRequest(ctx, req, item) {
  if (!req.getLayout) {
    // 要检查下能不能正常生成这个组件的layout
    const layout = genCompLayout(ctx, item);
    if (!layout) return;
    // 缓存到containerLayout里
    return {
      ...req,
      containerLayout: layout
    };
  }
  return req;
}
/** 默认的装入容器逻辑 */
async function defaultPlaceCompInside(item, designer, layoutTemp, path) {
  // 没有getLayout的时候一定有containerLayout
  const containerLayout = cloneDeep(item.containerLayout);
  designer.uc.completeLayout(containerLayout);
  // 将当前组件改为容器
  await designer.replaceCompWith(path, containerLayout);
  const insertPoint = `${path}/${item.slotId}/0`;
  // 将原本的组件装入容器
  // 其实本来可以将这一段逻辑直接补全到getLayout里的 但是spliceComp的能力不太好抽出来 所以最终在apply点选的时候直接用了
  await designer.spliceComp(null, insertPoint, layoutTemp);
}
/** 把ctx中的layout 按照PlaceCompsInsidePayload进行装入 */
export async function applyPlaceCompInside(ctx, item,
// ctx一般是操控一个单独的layout 但是这里可以复用来装入Layout[] 额外加个参数
layouts) {
  const {
    layout,
    path,
    designer
  } = ctx;
  // 缓存原本的layout
  const layoutTemp = cloneDeep(layouts || layout);
  // 自定义了替换函数
  if (item.getLayout) {
    // 生成装入后的layout
    const newLayout = await item.getLayout(arrayify(layoutTemp));
    // 将当前组件改为新的layout
    await designer.replaceCompWith(path, newLayout);
  } else if (item.slotId) {
    // 没有getLayout走一套默认行为
    await defaultPlaceCompInside(item, designer, arrayify(layoutTemp), path);
  } else {
    // 没有getLayout也没有slotId 期望是不会出现这种情况的
    console.error('PlaceCompInside error', item);
  }
}
/** 生成可以执行可装入容器的列表 */
export function genPlaceCompInsideAlternates(ctx) {
  const {
    designer
  } = ctx;
  // 有了placeCompInside说明是已做适配的组件,优先推荐
  const hasPlaceComp = designer.uc.componentsArray.filter(item => !!item.placeCompInside && !!item.placeCompInside(ctx) && item.visible).map(item => ({
    meta: item,
    typeCName: '可装入的容器'
  }));
  // 没有placeCompInside但是在布局里的也要推荐一下 给一个默认装入的策略 与具有placeCompInside的互斥 需要至少定义一个插槽
  const containerComp = designer.uc.componentsArray.filter(item => item.category === '布局' && !!get(item, ['slots', 0, 'id']) && item.visible && !item.placeCompInside).map(item => ({
    meta: item,
    typeCName: '布局'
  }));
  const placeAbleComps = [...hasPlaceComp, ...containerComp];
  const compMetaWithPlaceRequestArray = [];
  placeAbleComps.forEach(item => {
    // 这里统一把四种情况都封装为使用了PlaceCompInsideAdvancedRes的情况
    // 由一个compMeta 可以产生好多个PlaceInsideRequest
    // ctx.meta 被替换组件的meta , item.meta容器的meta , placeInsideRequest从容器meta中生成的替换请求
    const placeInsideRequests = wrapperPlaceInsideRequest(ctx, item.meta);
    // 每个Request 对应一个下拉面板中的东西 所以这里要根据Request的个数来继续扩充下拉列表
    placeInsideRequests
    // patch进可选的 {containerLayout?:UICore.Layout}
    .map(placeInsideRequest => checkRequest(ctx, placeInsideRequest, item.meta)).forEach(completedRequest => {
      if (completedRequest === undefined) return;
      compMetaWithPlaceRequestArray.push({
        // compMeta解构进来 作为name和icon的兜底
        ...item.meta,
        // 解构进typeCname字段 挂上meta
        ...item,
        // 用来排序的字段 暂时不需要 统一为'editor'
        type: 'editor',
        // 把PlaceCompInsideAdvancedRequest拍进来
        ...completedRequest
      });
    });
  });
  return compMetaWithPlaceRequestArray;
}
export function placeCompInsideAction(list, ctx) {
  const {
    meta,
    path,
    designer,
    instance
  } = ctx;
  if (path === '' || meta === undefined || path.startsWith('/@')) return list;
  // 只加入到属性面板里 防止冗余
  list.unshift({
    icon: svg,
    title: '装入容器',
    place: ['propPanel', 'contextMenu'],
    execute: () => {
      designer.openSettleComponentWindow({
        place: document.activeElement || instance.$el,
        compPath: path,
        title: '选择要装入的容器',
        dataPath: '',
        // 在用户点选选项列表中的某个组件时通过getLayout生成最终替换好的Layout并替换进编辑器中
        applyAlternateCallback: ({
          item
        }) => applyPlaceCompInside(ctx, item),
        // 定义了placeCompInside 或者属于布局容器的都纳入推荐列表
        getAlternates: () => genPlaceCompInsideAlternates(ctx)
      });
    }
  });
  return list;
}
//# sourceMappingURL=placeCompInsideActions.js.map
